import axios from 'axios'
import { useUserStore } from '~~/store/userStore'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const exceptions = [
        '/login',
        '/register',
        '/forgot-password',
        '/reset-password',
        '/password-reset-link-sent',
    ]

    if(exceptions.includes(to.path) || to.path.startsWith('/classi/')) {
        return
    }

    const { $startLoading, $stopLoading } = useNuxtApp()

    const { data: user, getData, setData } = useUserStore()
    const config = useRuntimeConfig()

    axios.defaults.withCredentials = true
    axios.defaults.headers.common['Accept'] = 'application/json'
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
    axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

    const tries = ref(0)
    const max_tries = ref(2)
    const timeout = 2000

    const getUserData = async () => {
        try {
        // 1) assicura CSRF cookie
        await axios.get(config.public.base_url + 'sanctum/csrf-cookie')
        // 2) ora puoi chiedere l’utente
        const { data } = await axios.get(config.public.api_url + 'user')
        return data
        } catch (e) {
        return false
        }
    }

    const attempt = async() => {
        tries.value++

        // console.log('tentativo ' + tries.value);

        const data = await getUserData()

        if(data) {
            const user_data = data.data || data

            setData(user_data)

            $stopLoading()

            return user_data
        }
        else {
            console.log('chiamata fallita')

            if(tries.value < max_tries.value) {
                // console.log('riprovo')

                $startLoading()

                await new Promise(r => setTimeout(r, timeout));

                return await attempt()
            }
            else {
                // console.log('tentativi finiti');

                return false
            }
        }
    }

    if(! user.id) {
        const user_data = await attempt()

        // console.log('fatto', user_data);

        if(! user_data) {
            $stopLoading()

            return navigateTo('/login')
        }

        const isLoggedIn = getData().id

        if(! isLoggedIn) {
            return navigateTo('/login')
        }
    }
    else {
        // console.log('ho già user id, proseguo')

        return true
    }
})
